export default "__VITE_ASSET__5a63e649__"